import { useContext, useMemo, useRef, forwardRef, useImperativeHandle } from "react";
import { Button } from "react-bootstrap";
import { Plus } from "react-feather";
import FormModal from "../../../components/FormModal";
import { UtilityContext } from "../../../contexts/UtilityContext";
import { createFamily } from "../../../services/families";
import familyColumns from "../../tables/columns/family";

const CreateCustomer = forwardRef(({ afterCreate }, ref) => {
  const { dropdownValues, exceptionOptions } = useContext(UtilityContext);
  const createFormRef = useRef({ open() {} });

  const columns = useMemo(
    () => familyColumns(dropdownValues, exceptionOptions),
    [dropdownValues, exceptionOptions]
  );

  const handleCreate = async (data) => {
    await createFamily(data);
    await afterCreate();
  };

  useImperativeHandle(ref, () => ({
    open: () => createFormRef.current.open({
      masbiahLocationId: dropdownValues.masbiahLocationId[0].value,
    })
  }));

  return (
    <>
      <FormModal
        ref={createFormRef}
        title="Create family"
        columns={columns}
        onSubmit={handleCreate}
      />
    </>
  );
});

export default CreateCustomer;
